import { render, staticRenderFns } from "./FormDecimalTwoByTwoInput.vue?vue&type=template&id=f5cb620e&"
import script from "./FormDecimalTwoByTwoInput.vue?vue&type=script&lang=js&"
export * from "./FormDecimalTwoByTwoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports